import { useStepsContext } from '@/providers/pi-multi-step-form/StepsContext';
import StepContainer from './step-container';
import Alert from '@/components/pages/alert';
import { injuries } from '@/lib/constants';
import clsx from 'clsx';
import { Money } from '@/components/pages/icons';

export default function WhatHappened() {
  const { caseTypeValue, nextStep, onCaseTypeChange } = useStepsContext();

  const onContinue = () => {
    nextStep();
  };

  const [currentValue] = caseTypeValue;

  return (
    <StepContainer
      title="What happened?"
      subtitle="This helps us assess your case and direct you to the right specialist."
      onSubmit={onContinue}
      buttonDisabled={!currentValue}
      buttonLabel="Next"
    >
      <>
        <div className="flex flex-wrap gap-2 justify-center mb-8">
          {injuries.map((item) => (
            <label
              key={`input-injury-${item.value}`}
              className={clsx(
                'flex items-center justify-center gap-2 rounded-full border text-brand-accent transition-colors cursor-pointer text-base font-semibold leading-[100%] min-h-12 w-full @lg:max-w-[calc(100%/2-0.5rem)] [&_svg]:w-4',
                currentValue === String(item.value)
                  ? 'bg-brand-accent text-white'
                  : 'border-brand-accent bg-transparent hover:bg-black/10 '
              )}
            >
              {item.icon}
              <span>{item.label}</span>
              <input
                name="help"
                type="radio"
                value={item.value}
                className="sr-only"
                onChange={onCaseTypeChange}
              />
            </label>
          ))}
        </div>

        <Alert icon={<Money />}>
          <p>
            Get <b>3.5x more</b> compensation with an attorney, on average. Pay <b>nothing</b>{' '}
            unless we win.
          </p>
        </Alert>
      </>
    </StepContainer>
  );
}
